<!-- modal 成功or失败 结算 -->
<template>
  <div class="game-result-modal">
    <div class="game-result-modal-content">
      <img
        :src="require(`@/assets/game/images/bg-${gameResult}-keduo.png`)"
        alt=""
        class="game-result-modal-content-bg-img"
        :class="{ 'fail-image': gameResult === 'fail' }"
      />
      <div class="game-result-modal-content-inner">
        <div class="game-result-modal-content-bg">
          <!-- score -->
          <div class="game-result-modal-content-score">
            <div class="score-item">
              <div class="score-value">{{ finishParams.correctness }}%</div>
              <div class="score-label">正确率</div>
            </div>
            <div class="score-item">
              <div class="score-value">{{ finishParams.timeStr }}</div>
              <div class="score-label">闯关用时</div>
            </div>
            <div class="score-item">
              <div class="score-value">
                {{ finishParams.velocity }}<span class="unit">键/分钟</span>
              </div>
              <div class="score-label">打字速度</div>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="game-result-modal-content-btn">
            <div class="btn-item-replay" @click="handleReplay"></div>
            <div
              v-if="showFinishButton"
              class="btn-item-finish"
              @click="finishCurrentLevel"
            ></div>
            <div
              class="btn-item-continue"
              v-if="gameResult === 'win' && showNextLevel"
              @click="handleContinue"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WXJsBridge from "@xes/wxjsbridge/src";
import { isStudentEnd } from "@/utils";
export default {
  props: {
    gameResult: {
      type: String,
      default: "",
    },
    finishParams: {
      type: Object,
      default: () => {},
    },
    showNextLevel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showFinishButton() {
      return (
        !this.showNextLevel && this.gameResult === 'win' &&
        (window.XesInstance.isMobileApp() || window.XesInstance.isWdFunction())
      );
    },
  },
  methods: {
    handleReplay() {
      console.log("再来一次");
      this.$emit("restart");
    },
    handleContinue() {
      console.log("继续闯关");
      this.$emit("nextLevel");
    },
    finishCurrentLevel() {
      this.$emit("finishCurrentLevel");
      if (isStudentEnd()) {
        // 在端上延迟关闭窗口, 防止页面关闭前数据未上报
        setTimeout(() => {
          if (window.XesInstance.isAndroidFunction()) {
            // eslint-disable-next-line no-undef
            WXJsBridge.closeWebView();
          } else {
            window.XesInstance && window.XesInstance.closeWindowFunction();
          }
        }, 500);
      } else {
        window.history.back();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.game-result-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  .game-result-modal-content {
    margin-top: 100px;
    width: 503px;
    height: 339px;
    border-radius: 30px 30px 50px 50px;
    background: linear-gradient(180deg, #acdaff 0%, #0192ff 74.7%);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .game-result-modal-content-bg-img {
      position: absolute;
      top: -205px;
      left: 66px;
      width: 370px;
      height: 274px;
      z-index: 1;
    }
    .fail-image {
      top: -184px;
      width: 370px;
      height: 240px;
    }
    .game-result-modal-content-inner {
      width: 491px;
      height: 325px;
      border-radius: 26px 26px 48px 48px;
      background: linear-gradient(180deg, #d2e4ee 0%, #b3cee7 74.7%);
      box-shadow: 0px 2px 2px 0px rgba(42, 42, 42, 0.25);
      display: flex;
      justify-content: center;
      align-items: center;

      .game-result-modal-content-bg {
        width: 483px;
        height: 321px;
        flex-shrink: 0;
        border-radius: 24px 24px 46px 46px;
        background: linear-gradient(180deg, #daeeff 0%, #fff 74.7%);
        box-shadow: 0px -4px 2px 0px rgba(159, 196, 220, 0.59) inset;
        position: relative;

        .game-result-modal-content-score {
          width: 443px;
          height: 123px;
          flex-shrink: 0;
          border-radius: 15px;
          background: #fff;
          box-shadow: 0px 0px 0px 1px #c2ddf3 inset;
          position: absolute;
          top: 42%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          justify-content: space-around;
          align-items: center;

          .score-item {
            display: flex;
            flex-direction: column;
            align-items: center;

            .score-label {
              color: #666;
              text-align: center;
              font-size: 16px;
              font-weight: 400;
              line-height: 25px;
              margin-top: 10px;
            }

            .score-value {
              color: #222;
              text-align: center;
              font-size: 25px;
              font-weight: 700;
              line-height: 25px;
              display: flex;
              align-items: center;
              justify-content: center;

              .unit {
                font-size: 16px;
                color: #666;
                font-weight: 400;
                line-height: 25px;
                text-align: center;
              }
            }
          }
        }
        .game-result-modal-content-btn {
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          transform: translate(0%, -50%);
          display: flex;
          justify-content: center;
          align-items: center;

          .btn-item-replay {
            width: 145px;
            height: 60px;
            background-image: url("../../../assets/game/images/btn-game-replay.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            margin-right: 10px;
          }
          .btn-item-continue {
            width: 145px;
            height: 60px;
            background-image: url("../../../assets/game/images/btn-game-next.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          .btn-item-finish {
            width: 145px;
            height: 60px;
            background-image: url("../../../assets/game/images/finish-btn.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
}
</style>
